import template from './userCardRow.html';
import controller from './userCardRow.controller';
import './userCardRow.scss';

let userCardRowComponent = {
  restrict: 'E',
  bindings: {
    originalCardState: '<',
    profile: '<',
    cards: '<',
    notifyModify: '&',
    notifySend: '&',
    cardDaysFocused: '&',
    onCloseCard: '&',
    isMobileApp: '<',
  },
  template,
  controller,
};

export default userCardRowComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/userCardRow.component.js